<template>
  <AppPageContainer :custom="1600" :min-height="0">
    <AppPageHeader
      design="new"
      title="Trengo"
      compact
    />
    <AppTabs
      design="new"
      refined
      weight="medium"
      :tabs="visibleTabs"
      :value="activeTab"
      @input="openTab"
    />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </AppPageContainer>
</template>

<script>
import AppTabs from '@/components/AppTabs'

const TABS = [
  { id: 'matching', value: 'crm-trengo-matching', label: 'Matching', roles: ['general_manager', 'marketing_supervisor'] },
  { id: 'matching-legacy', value: 'crm-trengo-matching-legacy', label: 'Matching Legacy', roles: ['general_manager', 'marketing_supervisor'] },
  { id: 'tickets', value: 'trengo-tickets', label: 'Tickets', roles: ['general_manager'] },
  { id: 'wa-webhooks', value: 'whatsApp-webhooks', label: 'WA Webhooks', roles: ['general_manager'] }
]

export default {
  name: 'TrengoWorkspaceLayout',
  components: { AppTabs },
  computed: {
    visibleTabs() {
      const roles = (this.$store.state.userGroups || []).map(role => role.code)
      let tabs = TABS
      if (roles.length) tabs = TABS.filter(tab => tab.roles.some(role => roles.includes(role)))
      return tabs.map(({ roles, ...tab }) => tab)
    },
    activeTab() {
      if (this.$route.name === 'trengo-tickets-detail') return 'trengo-tickets'
      return this.$route.name
    }
  },
  methods: {
    openTab(name) {
      if (name === this.activeTab) return
      this.$router.push({ name }).catch(() => {})
    }
  }
}
</script>
